import { createPaginatedSlice } from '../../../helpers/reduxHelper';

const paginatedAutomationExcelList = createPaginatedSlice('paginatedAutomationExcelList', {
  pagination: 'normal',
});

export const paginatedAutomationExcelListActions = paginatedAutomationExcelList.actions;
export const paginatedAutomationExcelListSelector = (state) => state.paginatedAutomationExcelList;
export const paginatedAutomationExcelListReducer = paginatedAutomationExcelList.reducer;
export default paginatedAutomationExcelList;

export const paginatedAutomationExcelListSelectors = paginatedAutomationExcelList.LF.selectors;
